(() => {
  const worker = window.swinger.webworker.jsonWorker;
  const resolvers = new Map();

  worker.addEventListener('message', (e) => {
    if (
      e.data.action !== 'jsonResult'
      || !e.data.payload
      || !e.data.result
    ) {
      return;
    }

    const resolver = resolvers.get(e.data.payload);

    if (!resolver) {
      return;
    }

    resolver(e.data.result);
  });

  const json = [
    'parse',
    'stringify',
  ].reduce((acc, method) => {
    acc[method] = (payload) => {
      worker.postMessage({
        action: method,
        payload,
      });

      return new Promise((resolve) => {
        resolvers.set(payload, resolve);
      });
    };

    return acc;
  }, {});

  window.swinger = window.swinger || {};
  window.swinger.json = json;
})();
